import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const PolicyStatusSchema = z.object({
	id: z.number().optional(),
	amsStatus: z.string().min(1, 'This field is required'),
	mappedStatus: z.string().min(1, 'This field is required'),
	description: z.string().min(1, 'This field is required'),
	isPrimaryStatus: z.boolean(),
	isPolicyStatus: z.boolean(),
	databaseInstanceId: z.number(),
	databaseInstanceName: z
		.string()
		.transform((val) => (val === '' ? null : val))
		.nullable()
		.optional(),
	isExpired: z.boolean().optional(),
});

export type PolicyStatus = z.infer<typeof PolicyStatusSchema>;

export const all = async (
	pagination: PaginationState,
	sorting: SortingState = [],
	params: object,
): Promise<{ data: PolicyStatus[]; total: number }> => {
	try {
		let queryString = '';
		if (params) {
			const paramsAsString = JSON.stringify(params)
				.replace(/:/g, '=')
				.replace(/,/g, '&')
				.replace(/[{}"]/g, '');

			const searchParams = new URLSearchParams(paramsAsString);
			if (pagination) {
				searchParams.append('pageSize', pagination.pageSize.toString());
				searchParams.append('pageIndex', pagination.pageIndex.toString());
			}

			if (sorting.length > 0) {
				searchParams.append('sortBy', sorting[0].id);
				searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
			}

			queryString = `?${searchParams.toString()}`;
		}

		const response = await fetch(`/PolicyStatus${queryString}`);

		return await response.json();
	} catch (err) {
		return {
			data: [],
			total: 0,
		};
	}
};

export const add = async (policyStatus: PolicyStatus): Promise<boolean> => {
	const res = await fetch(`/PolicyStatus`, {
		method: 'POST',
		body: JSON.stringify(policyStatus),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};

export const update = async (policyStatus: PolicyStatus): Promise<boolean> => {
	const res = await fetch(`/PolicyStatus`, {
		method: 'PATCH',
		body: JSON.stringify(policyStatus),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};
